export { default } from "bullitttime-embermodelsevent/models/entry";
